import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { takeUntil, debounceTime } from 'rxjs/operators';
import { Subject } from 'rxjs';
import {
  BASE_CUSTOMER_OFFER_STATUS_OPTIONS,
  BASE_PERMISSIONS,
  BaseFilterService,
  BaseInquiryOffersFilters,
  BaseOfferStatus,
  BaseQueryParamService,
  BaseRolesService,
  PspBranchFilterInfoResponse,
  QualificationShortInfoResponse,
} from 'base';
import { BaseCustomerInquiryExperienceOptionsConst } from '../../_const/base-customer-inquiry-offers-filters-options.const';
import { BASE_CUSTOMER_WORK_COUNCIL_APPROVAL_OPTIONS } from '../../../offers/_enums/base-customer-offers.enum';

@Component({
  selector: 'base-customer-inquiry-offers-list-filters',
  templateUrl: './inquiry-offers-list-filters.component.html',
})
export class InquiryOffersListFiltersComponent implements OnInit, OnDestroy {
  @Input() qualifications: QualificationShortInfoResponse[] = [];
  @Input() branches: PspBranchFilterInfoResponse[] = [];
  @Input() filterValues: { [key in any]: any };
  @Input() filtersForm: FormGroup;

  inquiryOffersFiltersType = BaseInquiryOffersFilters;
  baseOfferStatusOption = BASE_CUSTOMER_OFFER_STATUS_OPTIONS;
  baseCustomerWCApprovalOptions = BASE_CUSTOMER_WORK_COUNCIL_APPROVAL_OPTIONS;
  experienceOptions = BaseCustomerInquiryExperienceOptionsConst;

  activeFilters: any[] = [];
  labels: any = {
    status: 'state',
    rating: 'review',
    experience: 'tooltip.experienceInCompany',
    mainQualifications: 'qualifications.plural',
    workCouncilStatus: 'workCouncil.label',
    pspBranches: 'provider',
    search: 'search',
  };

  private destroy$ = new Subject();

  constructor(
    private queryParamsService: BaseQueryParamService,
    private rolesService: BaseRolesService,
    public filterService: BaseFilterService
  ) {}

  ngOnInit() {
    this.setStatusOptions();
    this.activeFilters = this.filterService.updateActiveFilters(this.filtersForm.getRawValue());

    this.filtersForm.valueChanges.pipe(takeUntil(this.destroy$), debounceTime(50)).subscribe(() => {
      this.activeFilters = this.filterService.updateActiveFilters(this.filtersForm.getRawValue());
      this.queryParamsService.filterSubject.next({
        filters: this.filtersForm.value,
      });
    });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
  }

  removeFilter(filter: { filter: string; value: string; name?: string }): void {
    this.filterService.removeFilter(this.filtersForm, filter);
  }

  clearFilters(): void {
    this.filtersForm.reset();
  }

  setStatusOptions(): void {
    const isOfferPreselectionAllowed =
      this.rolesService.hasAdminRole() ||
      this.rolesService.hasCustomerFeaturePermission(BASE_PERMISSIONS.FEATURE_PRESELECT_OFFERS);

    this.baseOfferStatusOption = isOfferPreselectionAllowed
      ? BASE_CUSTOMER_OFFER_STATUS_OPTIONS
      : BASE_CUSTOMER_OFFER_STATUS_OPTIONS.filter(
          (option) => option.id !== BaseOfferStatus.preselected && option.id !== BaseOfferStatus.declined
        );
  }
}
